export const requestClub = {
  CONFIRMED: 'confirmed',
  REQUEST: 'request',
  USER_REQUEST: 'userrequest',
};
